<script setup lang="ts">
import type { NumberFilterField } from "@/models/Column";

import { getFieldNames } from "./getNames";
import CaseSearchFieldDescription from "./CaseSearchFieldDescription.vue";

withDefaults(defineProps<{
  config: NumberFilterField;
  fieldPath: string;
  displayName: string;
  isCollection: boolean;
  lastSearch?: { value?: string };
}>(), {  })

const { fieldTypeName, fieldValueName, fieldIsCollectionName, fieldHelpTextId } = getFieldNames(__props.fieldPath, __props.config);
</script>
<template>
  <div class="max-w-md tw-relative tw-shrink-0 tw-space-y-1">
    <label
      tabindex="0"
      :for="fieldValueName"
      class="tw-block tw-text-sm tw-font-medium tw-underline-offset-2 tw-outline-none focus:tw-underline"
    >
      {{ displayName }}
    </label>
    <CaseSearchFieldDescription v-if="config.helpText" :id="fieldHelpTextId" :help-text="config.helpText" />
    <div class="tw-relative tw-w-full">
      <input type="hidden" :name="fieldTypeName" value="number" />
      <input type="hidden" :name="fieldIsCollectionName" :value="isCollection" />
      <input
        :id="fieldValueName"
        type="number"
        :max="config.max"
        :min="config.min"
        :name="fieldValueName"
        :aria-label="config.description"
        :aria-describedby="config.helpText ? fieldHelpTextId : undefined"
        :value="lastSearch?.value ?? config.defaultValue"
        class="tw-w-full tw-rounded-sm tw-border tw-p-1 tw-pr-4"
      />
    </div>
  </div>
</template>
